import useState from '@vindo/store/state'

/**
 * Export images
 */
export default function Select({width, value, radio, label, options, onChange}: any) {
  var state = useState({
    value: null,
    component: null,
    selecting: false
  })

  return (
    <div className="select">
      <div
        className="default"
        onClick={() => {
          state.set({selecting: state.selecting ? false : true})
        }}>
        <span className="text">
          {state.value ? (
            state.component ? state.component : state.value
          ):(
            value ? (typeof value === 'object' ? value.component : value) : label 
          )}
        </span>
        <i className="caret icon-caret-down"/>
      </div>

      {state.selecting && (
        <div
          className="options"
          style={{
            width: width ? width.option : 'auto'
          }}>
          {options?.map((item: any, key: number) => {
            var value:any = item
            var component:any = null

            if(typeof item == 'object') {
              value = item.value

              if(item.component) {
                component = item.component
              }
            }
            return (
              <span
                key={key}
                className={state.value === value ? 'value selected' : 'value'}
                onClick={() => {
                  if(onChange) {
                    onChange(item)
                  }
                  state.set({
                    value,
                    component,
                    selecting: false,
                  })
                }}>
                {radio && (
                  <span className="radio"/>
                )}

                {typeof item == 'object' && item.component ? (
                  component
                ):(
                  <span className="text">{value}</span>
                )}
              </span>
            )
          })}
        </div>
      )}
    </div>
  )
}